import { AssetReportFilters } from "./types";


// constants/report.constants.ts
export const DEFAULT_FILTERS: AssetReportFilters = {
  statusIds: [],
  assetTypeIds: [],
  dateFilterType: "1",
  startDate: "",
  endDate: ""
};

export const DATE_FILTER_OPTIONS = [
  { value: "1", label: "End of life / Expiry date" },
  { value: "2", label: "WarrantyDate" },
  { value: "3", label: "PurchaseDate" },
  { value: "4", label: "EffectiveDate" }
] as const;

export const COLUMN_LABELS: Record<string, string> = {
        "assetId": "Id",
        "assetName": "Name",
        "assetTag": "Tag",
        "assetStatus": "Status",
        "assetPurchasePrice": "Purchase Price",
        "assetRegistreredDate": "Registered Date",
        "assetLifeSpan": "Life Span",
        "assetCurrentValue": "Current Value",
        "assetContactName": "Contact Name",
        "assetContactEmail": "Contact Email",
        "assetContactPhone": "Contact Phone",
        "assetContactMobile": "Contact Mobile",
        "assetOrganisationName": "Organisation Name",
        "assetOrganisationEmail": "Organisation Email",
        "assetOrganisationPhone": "Organisation Phone",
        "assetLocation": "Location",
        "assetAgentName": "Agent Name",
        "assetAgentEmail": "Agent Email",
        "assetAgentPhone": "Agent Phone",
        "assetAgentMobile": "Agent Mobile",
        "assetAgentGroup": "Agent Group",
        "assetType": "Type",
        "isCriticalAsset": "Critical Asset",
        "assetEffectiveDate": "Effective Date",
        "assetAlert": "Alert",
        "assetCreatedAt": "Created At",
        "assetUpdatedAt": "Updated At",
        "assetIsActive": "Is Active",
        "assetDescription": "Description",
        "assetPurchaseDate": "Purchase Date",
        "assetWarrantyDate": "Warranty Date",
        "assetEndOfLife": "End Of Life",
        "assetSupplierName": "Supplier Name",
        "assetSupplierReference": "Supplier Reference",
        "assetOperatingSystem": "Operating System",
        "assetOperatingSystemVersion": "Operating System Version",
        "assetAzureEntraId": "Azure Entra ID",
        "assetGroup": "Group",
        "assetUserPrincipleName": "User Principle Name",
        "assetUserIsAccountEnabled": "User Account Enabled",
        "assetIsComplaint": "Compliant",
        "ticketCount": "Ticket Count",
        "effortFormatted": "Effort (Formatted)",
        "downtimeFormatted": "Downtime (Formatted)",
        "meanEffortPerIncident": "Mean Effort Per Incident",
        "meanTimeToRecovery": "Mean Time To Recovery",
        "meanTimeBetweenFailure": "Mean Time Between Failure",
};